import { PresidentePost } from '../posts/presidente';
import { GobernadorPost } from '../posts/gobernador';
import { BalotajePost } from '../posts/balotaje';
import { JefeGobiernoPost } from '../posts/jefeGobierno';
import { LegislativasPost } from '../posts/legislativas';
import { DiputadosPost } from '../posts/diputados';
import { SenadoresPost } from '../posts/senadores';

/**
 * Factory para obtener la instancia correcta de Post según tipo de elección
 * NOTA: Para balotaje, usar la lógica en parseData que ya detecta electionType === 'balotaje'
 * @param {string} typeElection - Tipo de elección (presidente, gobernador, legislativas, etc)
 * @returns {BaseElectionPost} Instancia del post correspondiente
 */
export function getElectionPost(typeElection) {
  switch (typeElection) {
    case 'presidente':
      return new PresidentePost();
      
    case 'gobernador':
      return new GobernadorPost();
      
    case 'jefeGobierno':
      return new JefeGobiernoPost();
      
    case 'legislativas':
      return new LegislativasPost();
      
    case 'diputados':
      return new DiputadosPost();
      
    case 'senadores':
      return new SenadoresPost();
      
    default:
      throw new Error(`Tipo de elección no soportado: ${typeElection}`);
  }
}

/**
 * Validar que el tipo de elección es válido
 */
export function isValidElectionType(typeElection) {
  const validTypes = [
    'presidente',
    'gobernador',
    'jefeGobierno',
    'legislativas',
    'diputados',
    'senadores'
  ];
  
  return validTypes.includes(typeElection);
}